export const demoData = {
  version: 1.0,
  title: "Adobe Sign Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step0_Titlecard"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Send and sign an agreement",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "With Adobe Sign—the preferred       e-signature solution for Microsoft—users can quickly and securely send documents, contracts, and digital forms in Teams from any device.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "78%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A Teams channel titled “Contracts” is open. The icon bar lists ten icons: Activity, Chat, Teams, Calendar, Calls, Files, Adobe Sign, and an ellipsis. The App and Helps icons are at the bottom. A purple icon sits at the bottom of the list of Teams channels. ",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Head to the Adobe Sign icon to get started",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "A purple pop-up points to the Adobe Sign icon.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Select the Adobe Sign tab",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6%",
              x: "17.3%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image3"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Adobe Sign Icon, the Adobe Sign view opens under the Chat tab. There is a list of three tabs at the top including Chat, Adobe Sign, and About. ",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Sign in to Adobe Sign",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "55%",
              x: "50.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image4"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Adobe Sign tab, a view opens that reads “Start using Adobe Sign.” A purple pop-up points to a button that reads “Authorize and Sign In.” ",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Enter the recipient’s email",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "25.6%",
              x: "34.94117647058823%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image5a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user signs in, a new view appears with Send for Signature and Manage Agreements tabs. The Send for Signature tab is open with a form that includes fields for Recipients, Message and Files. On the right-hand side there is an Options card which has check boxes next to “Password Protect” and Set Reminder,” and a drop down box with languages under “Recipients’ language.” A purple pop-up points to the Recipients field. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "25.6475%",
              x: "63.2132%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image5a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step1_Image5a",
              "AdobeSign_Step1_Image5b",
              "AdobeSign_Step1_Image5c",
              "AdobeSign_Step1_Image6",
            ],
          },
          screenReaderText:
            "In the same view, the user begins to type “william” in the Recipients field. In the same view, the user adds @fabrik to the Recipients field. In the same view, the user finishes typing william@fabrikam.com. An envelope icon appears at the right of the Recipients field, and next to it is a down carrot. A purple pop-up highlights the down carrot. ",
        },
        {
          id: 7,
          card: {
            transition: false,
            text:
              "Using the dropdown menu in the Recipients field, users can customize the authentication method for signatures, such as requiring a password for added security.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "79%",
              x: "20%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image7"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks the down carrot, in the same view a drop down menu appears titled Authentication with options Email, Password... and KBA beneath. Email has been selected. ",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Add an Agreement Name and personalize your message",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "42%",
              x: "28.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image8a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the fields below the header that reads 'Message,' which includes a field for the agreement name and message body. ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Attach the document using the Drag & Drop tile or the Add Files button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "54%",
              x: "56.2%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image8a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step1_Image8a",
              "AdobeSign_Step1_Image8b",
              "AdobeSign_Step1_Image8c",
              "AdobeSign_Step1_Image9a",
              "AdobeSign_Step1_Image9b",
              "AdobeSign_Step1_Image9c",
              "AdobeSign_Step1_Image9d",
              "AdobeSign_Step1_Image10",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "51%",
              x: "56.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image11"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks “Add files,” a white box appears with a header that reads “Select files.” On the left-hand side there are tabs that read “My Computer,” “Library,” and “Templates.” “My Computer” is selected. A purple pop-up highlights a button that reads “Choose Files from My Computer.” ",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "72.6%",
              x: "72%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image12"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks “Choose File from My Computer,” a File Explorer window appears including the PDF File “Contoso NDA.” A purple pop-up highlights a button that reads “Open.” ",
        },
        {
          id: 12,
          card: {
            transition: false,
            text:
              "Users can upload multiple documents from existing files, or use templates from the Template Library.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "20%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image13"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view returns to the “Send for Signature” view. The “Contosa NDA.pdf” file now appears under the Files heading",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Use the toggle to decide the signature order",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "21%",
              x: "35.1%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image14"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a toggle next to text that reads “Complete in Order.” ",
        },
        {
          id: 14,
          card: {
            transition: false,
            text:
              "Password protect documents, set reminders, and select the recipient’s language in the Options card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "54%",
              x: "73%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image15"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user clicks the toggle and it is now in the “on” position. A purple pop-up points to the Options card. ",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Click send",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "80%",
              x: "29.3%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image16"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a button that reads “Send.” ",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "View the confirmation message",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "46%",
              x: "73%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image17"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new view appears with a message with the header “’Contos NDA’ has been successfully sent for signature” and a text block below. A purple pop-up points to the message. ",
        },
        {
          id: 16,
          card: {
            transition: false,
            text:
              "Adobe Sign automatically detects the fields for signature, and agreements can be signed from any device. Once a document has been signed, the sender will be notified in Teams via the Adobe Sign bot.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "76%",
              x: "20%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image18a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up appears in the bottom right-hand corner.",
        },
        {
          id: 16,
          card: {
            transition: false,
            text:
              "Users can also send contracts directly from a Teams channel.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "86%",
              x: "20%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image18b"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, another purple pop-up appears in the bottom right-hand corner. ",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "Click on the Teams icon to view Teams channels",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "17%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image19"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the Teams icon. ",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "Add a tab from the channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6.3%",
              x: "41.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image20"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks on the Teams icon, the Contracts Channel view returns. A purple pop-up points to a plus button to the right of the tabs that read “Posts,” “Files,” and “Wiki.” ",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "Search for Adobe Sign from the list of apps",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "10%",
              x: "60%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image21"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new white box appears with a header that reads 'Add a tab.' There is a grid style list of available apps. A purple pop-up points to a search box in the top-right corner",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "22%",
              x: "38%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image22"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user searches “Adobe” and the grid style list shows icons for “Adobe Sign,” “Adobe Acrobat,” and “Adobe Creative Cloud.” ",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "Add the app",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "28%",
              x: "32%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image23"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks “Adobe Sign,” a new white box appears with the header “Adobe Sign.” A purple pop-up points to a button that reads 'Add.'",
        },
        {
          id: 22,
          card: {
            transition: false,
            text: "Save the tab",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "73.3%",
              x: "61.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image24"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks “Add,” a new white box appears that reads “Share the Adobe Sign tab to your channel to collaborate on document workflows. Select the save button to start using Adobe Sign.” A purple pop-up points to a button that reads “Save.” ",
        },
        {
          id: 23,
          card: {
            transition: false,
            text:
              "Follow the same steps as before to send a new document for signature from the Adobe Sign tab.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "20%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image25"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "The “Send for Signature” view returns. ",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Live Sign",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "Remotely sign documents live from any device with Adobe Sign for Microsoft Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "91.5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The Contracts channel on Teams appears. ",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Head to the calendar icon to get started",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "22.5%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the Calendar icon. ",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Create a calendar invite for a signing session",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6.2%",
              x: "87.8%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image3"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The Calendar view opens which shows the calendar for the user’s work week. A purple pop-up points to the plus sign next to a button that reads “New Meeting.” ",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Title the signing ceremony",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "17.5%",
              x: "8.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image4a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the “New Meeting” button, a new view appears with a header that reads 'New Meeting.' The view includes fields to add a title, required, attendees, and more. A purple pop-up points to the field that reads 'Add title.'",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Add the signer as an attendee",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "24%",
              x: "8.3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image4a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step2_Image4a",
              "AdobeSign_Step2_Image4b",
              "AdobeSign_Step2_Image5",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Contoso” into the “Add title” field. In the same view, a purple pop-up points to the “Add required attendees” field. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "30%",
              x: "8.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image6"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user types john@fabrikam.com. A drop-down box appears with an icon with a person and plus sign and text that reads “Invite john@fabrikam.com.” A purple pop-up points to the icon. ",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Add a meeting agenda",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "57%",
              x: "8.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image7a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user selected “john@fabrikam.com,” the email address appears in the “Add required attendees” box. A purple pop-up points to text that reads “Type details for this new meeting” in the bottom field. ",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Send the meeting invite",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6.5%",
              x: "88.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image7a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step2_Image7a",
              "AdobeSign_Step2_Image7b",
              "AdobeSign_Step2_Image7c",
              "AdobeSign_Step2_Image7d",
              "AdobeSign_Step2_Image7e",
              "AdobeSign_Step2_Image8",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Hi John! We’ll use this time to sign the NDA and talk through any questions you may have.” A purple pop-up points to a button that reads “Send.” ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "Join the meeting",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92.9%",
              x: "58.7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image9"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks the “Send” button, the view returns to the Calendar view. A purple pop-up points to a button that reads “Join” in a blue box that reads “Contoso NDA Signing” and below that, “Microsoft Teams Meeting.” ",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Open the conversation panel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "1.2%",
              x: "71.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image10"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks the “Join” button, a new view appears with a black background and an image in the center of a man’s face. A purple pop-up points to an icon on the top right of a speech bubble. ",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Click the ellipsis",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.2%",
              x: "93.9%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image11"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A panel opens from the right side with the header “Meeting chat.” Below the header is text with notifications and a field that reads “Type a new message.” A purple pop-up points to an ellipsis at the bottom of the panel. ",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Choose Adobe Sign from the list of apps",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "59%",
              x: "87%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image12"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A pop-up appears on top of the panel with a header that reads “Find an app” and app icons in a grid-style list. A purple pop-up points to the Adobe Sign icon. ",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Add the bot",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "49%",
              x: "68.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image13"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks the Adobe Sign icon, a pop-up appears in the center of the screen with a header that reads “Add Adobe Sign to this chat.” A purple pop-up points to the button that reads “Add Live Sign.” ",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "Look up the agreement by adding the signer’s email",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39%",
              x: "50.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image14"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new pop-up appears with the header “Adobe Sign Live Sign” and the steps “Select Agreement” and “Confirm and Share.” The step “Select Agreement” is highlighted. The text reads “Confirm or enter the name and email address of the signer, then select a document to be signed from the list of available files.” There are fields with headers that read “Signer” and “Email,” and below that “Title,” “Modified,” and “Recipients.” A purple pop-up points to “Enter email address...” under the “Email” header. ",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "80%",
              x: "41.5%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image15"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user enters john@fabrikam.com into the Email field and a check box appears on the right side of the field. The Signer field now reads “John Smith (Guest).",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "Choose the agreement and press next",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "49%",
              x: "33.5%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image16"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the text 'Contoso NDA' appears under the header “Title” along with a date and time under the header “Modified.” Under the header “recipients,” john@fabrikam.com is now listed along with “0 of 1 COMPLETED” below that. A purple pop-up points to “Contoso NDA.”",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "77.6%",
              x: "63.8%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image17"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the line that begins with the text “Contoso NDA” is selected. A purple pop-up highlights a button that reads “Next.” ",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "Share the agreement",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "77.5%",
              x: "62%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image20"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks “Next,” the pop-up moves to the “Confirm and Share” step. The text reads “Confirm the signer and their email address before sharing this agreement. The signer will then be able to open and sign the agreement.” A box below the text has an thumbnail of the “Contoso NDA” document with information about the Contoso NDA including the text “In Progress” under the header “Status.” A purple pop-up points to a button that reads “Share agreement.” ",
        },
        {
          id: 19,
          card: {
            transition: false,
            text:
              "A card will be generated in the meeting chat that can now be sent for participants to sign, and the signer will be prompted to share their screen.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "80%",
              x: "41.5%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image21a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the “Share agreement” button, the view returns to the Teams meeting view with the “Meeting chat” panel open. The “Meeting chat” panel shows messages from the Adobe Sign Bot. A purple pop-up highlights the chat message which reads: “Request for signature” and includes information about the Contoso NDA with a button that reads “Review and sign.” ",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "53.6%",
              x: "88.8%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image21b"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights the button that reads “Review and sign.” ",
        },
        {
          id: 21,
          card: {
            transition: false,
            text:
              "Once the signer shares their screen, all meeting attendees will be able to view the signing ceremony.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "41.5%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image22"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The user’s screen is shared. ",
        },
        {
          id: 22,
          card: {
            transition: false,
            text:
              "After affirming their identity, the document will open in the signer’s default web browser.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "41.5%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image23a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a white box appears with a header that reads “Adobe Sign.” ",
        },
        {
          id: 23,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "52.8%",
              x: "56.8%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image23b"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights a button that reads “Affirm,” asking the user to affirm their identity.  ",
        },
        {
          id: 24,
          card: {
            transition: false,
            text: "Click start to begin the signing experience",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "72%",
              x: "14%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image24"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A window appears with a header that reads “Adobe Sign.” The Contoso NDA document is displayed. A white pop-up appears that reads “View message from meaganb@contoso.com” and points to an icon with a chat bubble. A purple pop-up points to a yellow down arrow icon that reads “Start. ",
        },
        {
          id: 26,
          card: {
            transition: false,
            text: "Type a signature and press Apply",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "32%",
              x: "26.5%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image26a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user types “John Smith” as their signature.  ",
        },
        {
          id: 27,
          card: {
            transition: false,
            text: "Users can upload, type, or draw their signature.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "86%",
              x: "41.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image27"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 28,
          card: {
            transition: false,
            text: "Finalize the document by pressing Click to sign",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "81.2%",
              x: "45.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image28"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user has completed the signature, the view returns to the Contoso NDA document. At the bottom of the document, the signature line shows “John Smith.” A white pop-up that reads “Click to change” points to the signature line. ",
        },
        {
          id: 29,
          card: {
            transition: false,
            text:
              "Signers will receive an email confirmation with the completed agreement. Senders can access signed documents from the Manage Agreements window in the Adobe  Sign app.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "75%",
              x: "41.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step2_Image29"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new view appears with a message with the header “You’re all set.” The bottom of the message reads “Manage your Adobe Sign agreements” with a blue button that reads “Sign In.” ",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Stay organized with Manage Agreements",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step1_Image1"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "With the Adobe Sign app, users can easily keep track of multiple documents throughout the entire signature process without leaving Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "78%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The Contracts channel on Teams appears. ",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Click the Adobe Sign icon in Teams",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39.2%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the “Adobe Sign” icon on the left-hand side",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Choose the Adobe Sign tab",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6%",
              x: "17.3%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image3"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Adobe Sign icon, a new view appears in Teams with the Adobe Sign header. To the right of the header there are three tabs that read: “Chat,” “Adobe Sign,” and “About.” A purple pop-up points to the Adobe Sign tab. ",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Click on Manage Agreements",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "12.2%",
              x: "15%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image4"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks on the Adobe Sign tab, a new view appears with sub-tabs that read Send for Signature” and “Manage Agreements.” A purple pop-up points to the Manage Agreements sub-tab. ",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "View the dashboard to see a high-level summary of your documents",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "38.2%",
              x: "57%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image5"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Manage Agreements sub-tab, a new view appears that reads “Your agreements” in the top right-hand corner. Under a header that reads “In Progress,” a table appears with the columns “Recipients,” “Title,” 'Status,' and 'Modified' that lists two documents. A purple pop-up points to the table. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Select a document to view available actions",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "32%",
              x: "38.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image6"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to “Contoso NDA” under the column “Title.” ",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image7"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a white button that read “Open” and a blue button that reads “Remind” appear in the “Contoso NDA” row. A panel opens from the right with the header “Contoso NDA.” It includes a message that reads “Hi William, please review and sign this NDA. Cheers!” An “Actions” section lists actions including “Open Agreement,” “Reminders,” and more. A purple box highlights the panel. ",
        },
        {
          id: 8,
          card: {
            transition: false,
            text:
              "Check the activity dropdown to see if a document has been viewed",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "71%",
              x: "82.2%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image8"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the header “Activity” at the bottom of the panel. ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Click the Waiting for You tab to show agreements that need your signature",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "30%",
              x: "8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image9"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The right-hand panel now shows viewing history for the document under the header “Activity.” The top part reads “william@fabrikam viewed the document Feb 18, 2021 5:17 PM.” A purple pop-up points to a tab on the left-hand side that reads “Waiting for You (1).” ",
        },
        {
          id: 10,
          card: {
            transition: false,
            text:
              "View completed agreements in Teams, or download them as PDFs",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "33.3%",
              x: "7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image10"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The “Waiting for You” tab now shows with a table with the headers “Sender,” “Title,” and “Status.” A purple pop-up points to the tab that reads “Completed.” ",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Click on the contract to view the available options",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "32%",
              x: "55.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image11"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The “Completed” tab now opens with a table that shows “Recipients,” “Sender,” and “Title.” A purple pop-up points to “Contoso NDA” in the first row under “Title” with “Abhishek Patel” listed as the recipient. ",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image12"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The row starting with “Abhishek Patel” is now highlighted. ",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Use the filter button to narrow the date range",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "17%",
              x: "73.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image13"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "A purple pop-up highlights the “Filters” icon in the top right-hand corner. ",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "82%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image14"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a white pop-up with the header “Modified Date” and a drop down that reads “All Dates” appears below the Filters icon. A purple pop-up points to the pop-up. ",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Find specific agreements or users by using the search bar",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "19%",
              x: "81.3%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image15"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the pop-up disappears. A purple pop-up highlights a search box that reads “Search for agreements and users...” next to the filter icon. ",
        },
        {
          id: 16,
          card: {
            transition: false,
            text:
              "In the Manage Agreements tab, users can also create new templates and  web forms, and send documents to large groups.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image16"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up appears in the lower right-hand corner. ",
        },
        {
          id: 17,
          card: {
            transition: false,
            text:
              "Navigate to the Templates section and press the Create a Template button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "49%",
              x: "7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image17"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the tab “Templates” on the left-hand side. ",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "61%",
              x: "57%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image18"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "The “Templates” tab opens. A document icon appears with a header beneath it that reads “Create reusable templates” and a button that reads “Create a Template.” A purple pop-up highlights “Create a Template.” ",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "Provide a name for the template",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "32%",
              x: "20%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image19a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks “Create a Template,” a new view appears with the header “Create a Library Template” and a from with the fields “Template Name” and “Files.” There is a box on the right-hand side with the headers “Template Type” and “Who can use this template.” A purple pop-up highlights the “Template Name” field. ",
        },
        {
          id: 20,
          card: {
            transition: false,
            text:
              "Upload a file using the Drag & Drop field or the Add Files button",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "36.5%",
              x: "58.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image19a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step3_Image19a",
              "AdobeSign_Step3_Image19b",
              "AdobeSign_Step3_Image20",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Contoso vendor agreement” in the “Template Name” field. A purple pop-up highlights the link “Add Files” to the right of the “Files” header. ",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "51%",
              x: "56%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image21"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks “Add files,” a white pop-up box appears with the header “Select Files.” A purple pop-up highlights a button that reads “Choose Files from My Computer.” ",
        },
        {
          id: 22,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "29%",
              x: "25%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image22"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A File Explorer window appears showing the user’s Documents folder. A purple pop-up highlights the PDF titled “Contoso Vendor Agreement.” ",
        },
        {
          id: 23,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "81%",
              x: "79%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image23"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights the “Open” button in the bottom-right corner of the box.",
        },
        {
          id: 24,
          card: {
            transition: false,
            text:
              "Set the Template Type and determine who can use the template",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "37%",
              x: "74%",
            },
            beacon: {
              isVisible: false,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image24"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "File Explorer disappears and the view returns to the “Create a Library Template” view. A purple pop-up highlights the box on the right hand-side with the headers “Template Type” and “Who can use this template.” ",
        },
        {
          id: 25,
          card: {
            transition: false,
            text:
              "Press Preview & Add fields to indicate where a signature is needed in the form",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "66%",
              x: "23%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image25"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights a button that reads “Preview & Add Fields” at the bottom of the view. ",
        },
        {
          id: 26,
          card: {
            transition: false,
            text: "Add relevant fields",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "40%",
              x: "88%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image26"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new view appears displaying the “Contoso vendor agreement” document. There is a panel on the right that reads “Template properties” and includes drop-downs such as “Recipients” and “Signature Fields.” The “Signature Fields” drop-down has been opened and has options that read: “Signature,” “Initials,” “Signature Block,” and “Stamp.” A purple pop-up highlights the option “Signature.” ",
        },
        {
          id: 27,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "93.8%",
              x: "91.8%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image27"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a yellow box that reads “Signature” with a red asterisk appears at the bottom of the document. ",
        },
        {
          id: 28,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "79%",
              x: "40%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image28"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new view appears that reads “You have successfully created a new library template!” with a thumbnail of the Contoso vendor agreement document to the left. ",
        },
        {
          id: 29,
          card: {
            transition: false,
            text:
              "Follow this same process in the Web Forms tab to generate a URL to send users a hosted version of an agreement, or to embed the form into a website.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "79%",
              x: "40%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step3_Image29"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Track signature status with the Adobe Sign bot",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "The Adobe Sign bot helps users efficiently track the status of pending documents directly in Teams from any device.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "80%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "The Contracts channel on Teams appears. ",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Head to the Adobe Sign icon to get started",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "39%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the “Adobe Sign” icon on the left-hand side. ",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Type “Check status” in the chat bar",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "31%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image3a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText:
            "After the user clicks the Adobe Sign icon, a new view appears in Teams with the Adobe Sign header that is opened to the “Chat” tab. Within the Chat, a welcome message appears from the Adobe Sign Bot. A purple pop-up points to the message field at the bottom of the chat. ",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.7%",
              x: "71.25%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image3a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step4_Image3a",
              "AdobeSign_Step4_Image3b",
              "AdobeSign_Step4_Image4",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Check status.” A pop-up with the header “Suggestions” appears and reads “Check status.” ",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Enter the name of your document",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "91.7%",
              x: "31%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image5a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user’s message “Check status” appears in the chat. A message from the Adobe Sign Bot reads “What is the name of the document you are checking on?” A purple pop-up appears pointing to the message field. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.7%",
              x: "71.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image5a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step4_Image5a",
              "AdobeSign_Step4_Image5b",
              "AdobeSign_Step4_Image6",
            ],
          },
          screenReaderText:
            "In the same view, the user types “Contoso.” In the same view, the user finishes typing “Contoso NDA.” In the same view, the user’s message “Contoso NDA” appears in the chat. ",
        },
        {
          id: 7,
          card: {
            transition: false,
            text:
              "A card will appear in the chat with the current document status.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image8"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a message appears from the Adobe Sign Bot with the header 'Contoso NDA' and a thumbnail of the document. The message includes the options “Set Reminder” and “Download.” ",
        },
        {
          id: 8,
          card: {
            transition: false,
            text:
              "Click the Send Reminder button to automatically generate a reminder email to signers",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "75%",
              x: "32%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image9"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up highlights the Send Reminder button. ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Users can also check the status of contracts by @mentioning the Adobe  Sign bot directly within a Teams channel or from the Chat.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image10"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "After the user clicks “Send Reminders,” a message from the Adobe Sign Bot appears that reads Reminder sent to william@fabrikam.com. ",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Click on the Teams icon",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "18%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image11"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the Teams icon on the left panel. ",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "Type “@Adobe Sign” to message the Adobe Sign bot",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92.5%",
              x: "37%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image12"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view returns to the Contracts channel. A purple pop-up highlights the blue button New conversation at the bottom of the Posts tab. ",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "87%",
              x: "37.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image13"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user types “@adobe” in the chat box. A Suggestions pop-up appears with the suggestions Adobe Creative Cloud and Adobe Sign. A purple pop-up highlights the Adobe Sign icon. ",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "96%",
              x: "77%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image14"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the message field reads “Adobe Sign” in blue. A purple pop-up highlights the Send icon which pictures a paper airplane. ",
        },
        {
          id: 14,
          card: {
            transition: false,
            text:
              "Use the menu bar to see a list of options for how the Adobe Sign bot can assist",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "77%",
              x: "39.5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image15"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a post appears from the user, Megan Bowman. The message includes the words Adobe Sign in blue text and below that a message from the Adobe Sign Bot which begins with “Hello! I’m here to help you manage your documents.” A purple pop-up points to the message from the Adobe Sign Bot. ",
        },
        {
          id: 15,
          card: {
            transition: false,
            text:
              "In addition to showing the status of specific documents, the Adobe Sign  bot can also update all users in a Teams Channel about any pending signatures. Users can also check document status from the Chat.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "75%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image16"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up appears in the bottom right-hand corner. ",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "Click on the Chat icon",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "12%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image17"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the Chat icon on the left-hand side. ",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "Begin a chat with the Adobe Sign bot",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6.2%",
              x: "21.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image18"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6%",
              x: "27%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image19a"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 19,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "17.2%",
              x: "28.3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image19b"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "Type “Show docs for others”",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image20"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "88%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image20"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step4_Image20",
              "AdobeSign_Step4_Image21",
              "AdobeSign_Step4_Image22",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 22,
          card: {
            transition: false,
            text:
              "Scroll through documents waiting for signature using the arrows in the card",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50.5%",
              x: "65%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image23"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 23,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50.5%",
              x: "65%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image24"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 24,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "50.5%",
              x: "65%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image25"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 25,
          card: {
            transition: false,
            text:
              "Type “Show docs for me” to view documents that require your signature",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image26"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 26,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "85%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image26"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step4_Image26",
              "AdobeSign_Step4_Image27",
              "AdobeSign_Step4_Image28",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 27,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step4_Image29"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 5,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Get the Adobe Sign app in Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "To get the Adobe Sign app, head to the Teams Store",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "90.2%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step5_Image1"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "Work with your organization's admin to make sure the Adobe Sign app is available for your team.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "84%",
              x: "10%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step5_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Search the Teams Store",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "13%",
              x: "10%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step5_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Click the Adobe Sign tile",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "13%",
              x: "25%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step5_Image2"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: true,
            sequenceSources: [
              "AdobeSign_Step5_Image2",
              "AdobeSign_Step5_Image3a",
              "AdobeSign_Step5_Image3b",
              "AdobeSign_Step5_Image4",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Install the app",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "28%",
              x: "31%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeSign_Step5_Image5"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "Sign in to the Adobe Sign account directly from the app to begin  collaborating and sharing assets",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "45%",
              x: "33.8%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeSign_Step5_Image6"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "Work with your Teams admin to pin the Adobe Sign app to the menu bar  for your entire org, displaying the tools most relevant to your users",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "40%",
              x: "0.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step5_Image7"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "The Adobe Sign bot provides key messages to help get users started.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "85%",
              x: "30%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step5_Image8"],
            imageAltText: "Microsoft Teams desktop user interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 7,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeSign_Step6_endcard"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
